import { type } from '@/utils/type'

export const AUTH_SUCCESS =  type('AUTH_SUCCESS')
export const AUTH_ERROR =  type('AUTH_ERROR')

export const AUTH_USER_SUCCESS =  type('AUTH_USER_SUCCESS')
export const AUTH_USER_ERROR =  type('AUTH_USER_ERROR')

export const AUTH_LOGOUT_SUCCESS =  type('AUTH_LOGOUT_SUCCESS')
export const AUTH_LOGOUT_ERROR =  type('AUTH_LOGOUT_ERROR')

export const AUTH_PASSWORD_SUCCESS =  type('AUTH_PASSWORD_SUCCESS')
export const AUTH_PASSWORD_ERROR =  type('AUTH_PASSWORD_ERROR')

export const AUTH_CHANGE_PASSWORD_SUCCESS =  type('AUTH_CHANGE_PASSWORD_SUCCESS')
export const AUTH_CHANGE_PASSWORD_ERROR =  type('AUTH_CHANGE_PASSWORD_ERROR')

export const AUTH_CREATE_PASSWORD_SUCCESS =  type('AUTH_CREATE_PASSWORD_SUCCESS')
export const AUTH_CREATE_PASSWORD_ERROR =  type('AUTH_CREATE_PASSWORD_ERROR')

export const AUTH_CREATE_ACCOUNT_SUCCESS =  type('AUTH_CREATE_ACCOUNT_SUCCESS')
export const AUTH_CREATE_ACCOUNT_ERROR =  type('AUTH_CREATE_ACCOUNT_ERROR')


